<template>
    <div id="main" class="layout-row flex">
        <!-- ############ Aside START-->
        <div id="aside" class="page-sidenav no-shrink bg-white nav-dropdown fade sticky" aria-hidden="true">
            <div class="sidenav h-100 modal-dialog bg-white">
                <!-- sidenav top -->
                <!-- Flex nav content -->
                <div class="flex scrollable hover">
                    <div class="nav-active-text-primary" data-nav>
                        <ul class="nav bg">
                            <li class="nav-header hidden-folded">
                                <span class="text-muted">{{ $t('nav.report') }}</span>
                            </li>
                            <li>
                                <router-link to="/">
                                    <span class="nav-icon text-primary"><font-awesome-icon icon="fa-solid fa-chart-line" /></span>
                                    <span class="nav-text">{{ $t('nav.dashboard') }}</span>
                                </router-link>
                                <router-link to="/my_report">
                                    <span class="nav-icon text-danger"><font-awesome-icon icon="fa-solid fa-cube" /></span>
                                    <span class="nav-text">{{ $t('nav.my-report') }}</span>
                                </router-link>
                            </li>
                            <li class="nav-header hidden-folded">
                                <span class="text-muted">{{ $t('nav.func') }}</span>
                            </li>
                            <li>
                                <a href="javascript:void(0)">
                                    <span class="nav-icon text-info"><font-awesome-icon icon="fa-solid fa-sack-dollar" /></span>
                                    <span class="nav-text">{{ $t('nav.revenue') }}</span>
                                    <span class="nav-caret"></span>
                                </a>
                                <ul class="nav-sub nav-mega">
                                    <li>
                                        <router-link to="/offer">
                                            <span class="nav-text">{{ $t('nav.offer') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/payment">
                                            <span class="nav-text">{{ $t('nav.payment') }}</span>
                                        </router-link>
                                    </li>
                                    <li v-if="userRole == 1">
                                        <router-link to="/cashin_report">
                                            <span class="nav-text">{{ $t('nav.cashin') }}</span>
                                        </router-link>
                                    </li>
                                    <li v-if="userRole == 1">
                                        <router-link to="/revenue_report">
                                            <span class="nav-text">{{ $t('nav.account') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/ar_report">
                                            <span class="nav-text">{{ $t('nav.ar') }}</span>
                                        </router-link>
                                    </li>
                                    <li v-if="userRole == 1">
                                        <router-link to="/invoice_management">
                                            <span class="nav-text">{{ $t('nav.invoice') }}</span>
                                        </router-link>
                                    </li>
                                    <li v-if="userRole == 1">
                                        <a href="#" class="">
                                            <span class="nav-text">{{ $t('nav.backout') }}</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="javascript:void(0)">
                                    <span class="nav-icon text-danger"><font-awesome-icon icon="fa-solid fa-mug-hot" /></span>
                                    <span class="nav-text">{{ $t('nav.crm') }}</span>
                                    <span class="nav-caret"></span>
                                </a>
                                <ul class="nav-sub nav-mega">
                                    <li>
                                        <router-link to="/events">
                                            <span class="nav-text">{{ $t('nav.events') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/client">
                                            <span class="nav-text">{{ $t('nav.client') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/contract_list">
                                            <span class="nav-text">{{ $t('nav.contract') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/my_target_list">
                                            <span class="nav-text">{{ $t('nav.my-target') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="javascript:void(0)">
                                    <span class="nav-icon text-dark"><font-awesome-icon icon="fa-solid fa-briefcase" /></span>
                                    <span class="nav-text">{{ $t('nav.admin') }}</span>
                                    <span class="nav-caret"></span>
                                </a>
                                <ul class="nav-sub nav-mega">
                                    <li>
                                        <router-link to="/ask_for_leave">
                                            <span class="nav-text">{{ $t('nav.ask-for-leave') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/reimbursement">
                                            <span class="nav-text">{{ $t('nav.reimbursement') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/meeting">
                                            <span class="nav-text">{{ $t('nav.meeting') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/namecard">
                                            <span class="nav-text">{{ $t('nav.card') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/courier">
                                            <span class="nav-text">{{ $t('nav.courier') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li v-if="userRole == 1">
                                <a href="javascript:void(0)">
                                    <span class="nav-icon text-warning"><font-awesome-icon icon="fa-solid fa-user-group" /></span>
                                    <span class="nav-text">{{ $t('nav.staff') }}</span>
                                    <span class="nav-caret"></span>
                                </a>
                                <ul class="nav-sub nav-mega">
                                    <li>
                                        <router-link to="/staff_list">
                                            <span class="nav-text">{{ $t('nav.staff') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/onboarding">
                                            <span class="nav-text">{{ $t('nav.onboarding') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/leaver_list">
                                            <span class="nav-text">{{ $t('nav.leave') }}</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/salary_list">
                                            <span class="nav-text">{{ $t('nav.salary') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="nav">
                            <li class="nav-header hidden-folded">
                                <span class="text-muted">{{ $t('nav.personal') }}</span>
                            </li>
                            <li>
                                <router-link to="/bonus_check">
                                    <span class="nav-icon text-primary"><font-awesome-icon icon="fa-solid fa-rocket" /></span>
                                    <span class="nav-text">{{ $t('nav.bonus-check') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/task">
                                    <span class="nav-icon text-success"><font-awesome-icon icon="fa-solid fa-list-check" /></span>
                                    <span class="nav-text">{{ $t('nav.task') }}</span>
                                    <span class="nav-badge"><b class="badge-circle xs text-success"></b></span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/my_profile">
                                    <span class="nav-icon text-warning"><font-awesome-icon icon="fa-solid fa-address-card" /></span>
                                    <span class="nav-text">{{ $t('nav.my-profile') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/settings">
                                    <span class="nav-icon text-danger"><font-awesome-icon icon="fa-solid fa-gear" /></span>
                                    <span class="nav-text">{{ $t('nav.settings') }}</span>
                                </router-link>
                            </li>
                        </ul>
                        <ul class="nav ">
                            <li class="nav-header hidden-folded">
                                
                                    <span class="text-muted">{{ $t('nav.help') }}</span>
                            </li>
                            <li>
                                <a href="http://help.kingfisherchina.com" target="_blank">
                                    <span class="nav-icon text-success"><font-awesome-icon icon="fa-solid fa-circle-question" /></span>
                                    <span class="nav-text">{{ $t('nav.help') }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- sidenav bottom -->
                <div class="no-shrink ">
                    <div class="p-3 d-flex align-items-center">
                        <div class="text-sm hidden-folded text-muted">
                            {{ $t('task.task') }}: 35%
                        </div>
                        <div class="progress mx-2 flex" style="height:4px;">
                            <div class="progress-bar gd-success" style="width: 35%"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ############ Aside END-->
        
        <div id="content" class="flex ">
            <!-- ############ Main START-->
            <div class="page-container">
                <slot></slot>
            </div>
            <!-- ############ Main END-->
        </div>
        <!-- ############ Content END-->
    </div>
</template>
<script>
export default {
  name: 'nav',
  props: ['message'],
  components: {
    
  },
  data: function() {
    return {
      notification: [],
      
    }
  },
  watch: {
    
  },
  computed: {
    userRole: function() {
      return localStorage.getItem('role')
    }
  },
  methods: {
    
    
  },
  mounted: function() {
    
  }
}
</script>